const reEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const rePhone = /^[()0-9\- ]*$/;
const passwordValidator = require('password-validator');

function validateEmail(email) {
  return reEmail.test(email);
}

function validatePhone(phone) {
  return rePhone.test(phone);
}

function validatePassword(password) {
  const passwordSchema = new passwordValidator();
  passwordSchema
    .is()
    .min(8) // Minimum length 8 characters
    .has()
    .uppercase() // Must have uppercase letters
    .has()
    .lowercase() // Must have lowercase letters
    .has()
    .digits(); // Must have digits
  if (passwordSchema.validate(password)) {
    return true;
  }

  return false;
}

module.exports = {
  validateEmail,
  validatePhone,
  validatePassword
};



// WEBPACK FOOTER //
// ./src/modules/misc/lib/validators.js